export default __webpack_public_path__ + "static/first-786f9f34475bbc9f94211b5abfef8dd2.png";